// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_6j-4";
export var collapsed = "_6j-1";
export var headerBar = "_6j-0";
export var leftHeaderContent = "_6j-3";
export var subjectContainer = "_6j-2";